// Debug version to identify the exact issue
window.postalHandler = {
  zones: null,
  product: null,
  
  init: function() {
    console.log('Handler init starting...');
    
    // Hide Alue options immediately
    this.hideAlueOptions();
    
    // Load zones immediately
    this.loadZones();
    
    // Get product data
    this.loadProduct();
    
    // Bind click event using direct reference to avoid conflicts
    const btn = document.getElementById('postal-check-btn');
    console.log('Button found for binding:', !!btn);
    
    if (btn) {
      btn.onclick = (e) => {
        console.log('Button clicked via onclick!');
        this.handleClick(e);
      };
      
      // Also try addEventListener as backup
      btn.addEventListener('click', (e) => {
        console.log('Button clicked via addEventListener!');
        this.handleClick(e);
      });
    }
    
    console.log('Handler init complete');
  },
  
  hideAlueOptions: function() {
    console.log('Hiding Alue options...');
    const alueInputs = document.querySelectorAll('input[name="Alue"], select[name="Alue"]');
    console.log('Found Alue inputs:', alueInputs.length);
    
    alueInputs.forEach(el => {
      const container = el.closest('fieldset') || el.closest('.form-field') || el.parentElement;
      if (container) {
        container.style.display = 'none';
        console.log('Hidden Alue container');
      }
    });
  },
  
  loadZones: function() {
    const url = document.getElementById('postal-check')?.getAttribute('data-zones-url');
    console.log('Loading zones from:', url);
    
    if (!url) {
      console.log('No zones URL found');
      return;
    }
    
    fetch(url)
      .then(response => {
        console.log('Zones response:', response.status);
        return response.json();
      })
      .then(data => {
        this.zones = data;
        console.log('Zones loaded:', this.zones);
      })
      .catch(err => {
        console.log('Zones load error:', err);
      });
  },
  
  loadProduct: function() {
    try {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      console.log('Form found:', !!form);
      
      const pid = form?.getAttribute('data-product-id');
      console.log('Product ID:', pid);
      
      const jsonEl = pid ? document.getElementById('ProductJson-' + pid) : null;
      console.log('Product JSON element found:', !!jsonEl);
      
      if (jsonEl) {
        this.product = JSON.parse(jsonEl.textContent);
        console.log('Product loaded, variants:', this.product?.variants?.length);
      }
    } catch (e) {
      console.log('Product load error:', e);
    }
  },
  
  handleClick: function(e) {
    console.log('=== HANDLE CLICK STARTED ===');
    
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    const postal = document.getElementById('postal-input')?.value?.trim();
    console.log('Postal code:', postal);
    
    // Basic validation
    if (!/^\d{5}$/.test(postal)) {
      console.log('Invalid postal format');
      this.setStatus('Anna voimassa oleva 5-numeroinen postinumero.');
      return;
    }
    
    if (!this.zones) {
      console.log('Zones not loaded');
      this.setStatus('Ladataan palvelualueita...');
      return;
    }
    
    // Get selected service (simplified approach)
    const service = this.getSelectedService();
    console.log('Selected service:', service);
    
    if (!service) {
      this.setStatus('Valitse ensin palvelu.');
      return;
    }
    
    // Find zone
    const zone = this.findZone(parseInt(postal));
    console.log('Found zone:', zone);
    
    if (!zone) {
      this.setStatus('Valitettavasti palvelu ei ole saatavilla alueellasi.');
      return;
    }
    
    // Find and update variant
    const variantId = this.findVariant(service, zone);
    console.log('Found variant ID:', variantId);
    
    if (!variantId) {
      this.setStatus('Tälle yhdistelmälle ei löytynyt tuotevaihtoehtoa.');
      return;
    }
    
    this.updateVariant(variantId);
    this.updateProperties(postal, zone);
    this.setStatus('Palvelu saatavilla.', true);
    
    console.log('=== HANDLE CLICK COMPLETED ===');
  },
  
  getSelectedService: function() {
    // For products using variant selector instead of separate option inputs
    if (!this.product?.variants) {
      console.log('No product variants available');
      return null;
    }
    
    // Get current variant ID from form
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form?.querySelector('input[name="id"]');
    const currentVariantId = idInput?.value;
    
    console.log('Current variant ID from form:', currentVariantId);
    
    if (currentVariantId) {
      // Find the variant object and get its option1 (service)
      const currentVariant = this.product.variants.find(v => v.id == currentVariantId);
      if (currentVariant && currentVariant.option1) {
        console.log('Service from current variant:', currentVariant.option1);
        return currentVariant.option1;
      }
    }
    
    // Fallback: try to find any available service from variants
    const firstVariant = this.product.variants[0];
    if (firstVariant && firstVariant.option1) {
      console.log('Service from first variant (fallback):', firstVariant.option1);
      return firstVariant.option1;
    }
    
    console.log('No service found from variants');
    return null;
  },
  
  findZone: function(postalCode) {
    if (!this.zones?.tiers) return null;
    
    for (const tier of this.zones.tiers) {
      for (const range of tier.ranges) {
        const from = range[0];
        const to = range.length > 1 ? range[1] : range[0];
        if (postalCode >= from && postalCode <= to) {
          return tier.name;
        }
      }
    }
    return null;
  },
  
  findVariant: function(service, zone) {
    if (!this.product?.variants) return null;
    
    const variant = this.product.variants.find(v => 
      v.option1 === service && v.option2 === zone
    );
    return variant?.id || null;
  },
  
  updateVariant: function(variantId) {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form?.querySelector('input[name="id"]');
    
    if (!idInput) return;
    
    console.log('Updating variant ID to:', variantId);
    idInput.value = variantId;
    
    // Get the variant object for price info
    const variant = this.product?.variants?.find(v => v.id == variantId);
    if (!variant) return;
    
    console.log('Variant details:', variant);
    
    // Method 1: Trigger standard Shopify events
    const changeEvent = new Event('change', { bubbles: true });
    idInput.dispatchEvent(changeEvent);
    
    // Method 2: Trigger form change
    form.dispatchEvent(new Event('change', { bubbles: true }));
    
    // Method 3: Update price elements directly (for Electro theme)
    this.updatePriceElements(variant);
    
    // Method 4: Trigger variant selector change if it exists
    const variantSelector = document.querySelector('select[name="id"], .variant-selector select');
    if (variantSelector) {
      variantSelector.value = variantId;
      variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Method 5: Update URL to trigger theme price refresh
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
    
    // Method 6: Force section refresh (Electro specific)
    setTimeout(() => this.refreshPriceSection(variantId), 100);
  },
  
  updatePriceElements: function(variant) {
    if (!variant.price) return;
    
    console.log('Updating price elements with:', variant.price);
    
    // Only target the main product price area, not recommended products
    const mainProductSection = document.querySelector('.product, .product__info, [data-section-type="product"], .main-product');
    
    if (!mainProductSection) {
      console.log('Main product section not found');
      return;
    }
    
    // Find price elements ONLY within the main product section
    const priceSelectors = [
      '.price',
      '.product__price', 
      '[data-product-price]',
      '.money',
      '.price-current',
      '.current-price'
    ];
    
    // Format price (Shopify price is in cents)
    const formattedPrice = this.formatPrice(variant.price);
    console.log('Formatted price:', formattedPrice);
    
    priceSelectors.forEach(selector => {
      const elements = mainProductSection.querySelectorAll(selector);
      elements.forEach(el => {
        // Only update if it looks like a price element
        if (el.textContent && /\d/.test(el.textContent) && /€|EUR|\$/.test(el.textContent)) {
          const oldPrice = el.textContent;
          el.textContent = formattedPrice;
          console.log('Price updated:', oldPrice, '->', formattedPrice);
        }
      });
    });
  },
  
  formatPrice: function(cents) {
    // Format price according to Finnish locale
    const euros = (cents / 100).toFixed(2);
    return `${euros}€`;
  },
  
  refreshPriceSection: async function(variantId) {
    try {
      // Get section ID from form or page
      const sectionId = document.querySelector('[data-section-id]')?.getAttribute('data-section-id');
      if (!sectionId) return;
      
      console.log('Refreshing section:', sectionId);
      
      // Fetch updated section HTML
      const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
      const response = await fetch(url);
      
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update price elements from fresh HTML
        const priceSelectors = [
          '.price',
          '.product__price',
          '[data-product-price]'
        ];
        
        priceSelectors.forEach(selector => {
          const newEl = doc.querySelector(selector);
          const currentEl = document.querySelector(selector);
          if (newEl && currentEl) {
            currentEl.innerHTML = newEl.innerHTML;
            console.log('Section price refreshed for:', selector);
          }
        });
      }
    } catch (error) {
      console.log('Section refresh failed:', error);
    }
  },
  
  updateProperties: function(postal, zone) {
    const propPostal = document.getElementById('prop-postal');
    const propZone = document.getElementById('prop-zone');
    
    if (propPostal) propPostal.value = postal;
    if (propZone) propZone.value = zone;
    
    console.log('Properties updated:', postal, zone);
  },
  
  setStatus: function(text, isSuccess = false) {
    const statusEl = document.getElementById('postal-status');
    if (statusEl) {
      statusEl.textContent = text;
      statusEl.className = 'postal-status ' + (isSuccess ? 'ok' : 'err');
    }
    console.log('Status set:', text, isSuccess);
  }
};

// Initialize when DOM is ready, with multiple fallbacks
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(() => window.postalHandler.init(), 1000);
  });
} else {
  setTimeout(() => window.postalHandler.init(), 1000);
}